// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1BC7k","choiceBoxes":"toolbarselects_choiceBoxes__14Cri","simpleField":"toolbarselects_simpleField__DR-TT"};